// extracted by mini-css-extract-plugin
export default {"checkboxRoot":"Checkbox_checkboxRoot__AmLF8","error":"Checkbox_error__TT3ra","checkboxIndicator":"Checkbox_checkboxIndicator__NgOBD","label":"Checkbox_label__rS-wV"};